import moment from 'moment';
import '../../helpers/moment-range';

/**
 * Returns true if sessions schedule overlap
 * @param {object} session1 First session for comparison
 * @param {object} session2 Second session for comparison
 * @returns boolean
 */
export function isSessionOverlaping(session1, session2) {
    let s1 = moment.range(session1.start_utc, session1.end_utc),
        s2 = moment.range(session2.start_utc, session2.end_utc);
    return s1.overlaps(s2);
}
